<template>
  <div class="menu">
    <div class="menu__logo">
      <img class="menu__logo-img" src="static/svg/logo-white.svg" />
    </div>
    <div class="menu__title">
      <span v-html="title"></span> / <b>{{pad(parseInt(pageIndex) + 1)}}</b> <span v-html="pageMenuTitle"></span>
    </div>
    <div class="menu__right-align">
      <a class="menu__print-link" v-if="menuOpen" :href="printerUrl">
        {{translations['printCTA']}}
      </a>
      <span class="menu__burger" v-bind:class="{ 'menu__burger--open': menuOpen }" @click="toggleMenu">
        {{translations['menuCTA']}}
        <em></em>
      </span>
    </div>
    <ul class="menu__list" v-bind:class="{ 'menu__list--open': menuOpen }">
      <div class="menu__list-innerwrap">
        <li v-for="(page, index) in pages" class="menu__list-item" :key="index">
          <router-link class="menu__list-link" v-on:click.native="closeMenu" v-bind:class="{ 'menu__list-link--active': pageIndex === index }" :to="routerArray(index)">
            <b>{{pad(index + 1)}}</b>
            <span v-html="page.menuTitle"></span>
          </router-link>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const getRouterArray = (index, get) => {
  const arr = {};
  arr.params = {};
  arr.params.id = index;
  arr.name = get.pages[arr.params.id].template;

  if (arr.name === '360') {
    arr.params.tViewIndex = 0;
    arr.params.canopy = 'canopy';
    arr.params.info = 'info';
    arr.params.selectedBullet = -1;
  }

  if (arr.name === 'installation-3d') {
    arr.params.info = 'info';
    arr.params.selectedBullet = -1;
  }
  return arr;
};

export default {
  name: 'MenuBar',
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    ...mapGetters(['translations', 'title', 'pageIndex', 'pageMenuTitle', 'pages', 'printUrl']),
    printerUrl() {
      return `${this.printUrl}`;
    },
  },
  methods: {
    pad(index) {
      const s = '000000000' + index; //eslint-disable-line
      return s.substr(s.length - 2);
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    routerArray(index) {
      return getRouterArray(index, this.$store.getters);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../scss/helpers';

.menu {
  display: block;
  height: 70px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  background: $c_primary;
  padding: 18px 20px;
  box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.1);
  z-index: 10;
  color: $c_white;

  @include not-mobile {
    padding: 18px 40px;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: $c_primary;
    z-index: -1;
  }

  &__logo {
    display: inline-block;
    vertical-align: middle;

    img {
      display: block;
    }
  }

  &__title {
    @include mobile {
      display: none;
    }

    @include not-mobile {
      display: inline-block;
      line-height: 34px;
      margin-left: 20px;
      @include t_normal;
      font-size: 16px;


      b {
        @include t_bold;
      }
    }
  }

  &__right-align {
    float: right;
  }

  @mixin menuLink {
    @include t_bold;
    display: inline-block;
    color: $c_white;
    font-size: 16px;
    line-height: 34px;
    text-decoration: none;
    cursor: pointer;
  }

  &__print-link {
    @include menuLink;

    &::after {
      display: inline-block;
      content: '';
      width: 21px;
      height: 20px;
      background: url('../../static/svg/icon_download.svg') no-repeat center;
      margin-left: 10px;
      margin-top: 4px;
      vertical-align: top;
    }
  }

  &__burger {
    @include menuLink;
    margin-left: 20px;

    @include not-mobile {
      margin-left: 40px;
    }

    em {
      width: 14px;
      height: 1px;
      background: $c_white;
      margin: 11px 0 12px 10px;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      transition: background .45s;

      &::before,
      &::after {
        display: block;
        width: 100%;
        height: 100%;
        background: $c_white;
        position: absolute;
        content: '';
        transition: top .45s, bottom .45s, width .45s, transform .45s;
      }

      &::before {
        top: -5px;
        left: 0;
        transform-origin: 0 0;
      }

      &::after {
        bottom: -5px;
        left: 0;
        transform-origin: 0 100%;
      }
    }

    &--open em {
      background: transparent;

      &::before,
      &::after {
        width: 17.3px;
      }

      &::before {
        transform: translateY(-1px) rotate(45deg);
      }

      &::after {
        transform: translateY(1px) rotate(-45deg);
      }
    }
  }

  &__list {
    // display: none;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 70px;
    z-index: -2;
    margin: 0;
    list-style: none;
    background-color: $c_primary;
    box-sizing: border-box;
    transition: transform .4s, opacity .4s;
    overflow: auto;
    // @include gradientBackground(true);
    padding: 0;
    box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.1);

    &::before {
      @include gradientBackgroundDarkOverlay;
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      @include not-mobile {

      }
    }

    @include not-mobile {
      // padding: 60px;
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      top: auto;
      max-height: calc(100vh - 70px);
      // column-count: 3;
    }

    @include landscape {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 70px;
      max-height: none;
      column-count: initial;
    }

    @include not-tablet {
      // column-count: 4;
    }

    &:not(&--open) {
      transform: translateY(100%);
      opacity: 0;
    }
  }

  &__list-innerwrap {
    position: relative;
    z-index: 1;
    max-height: 100%;
    overflow: auto;
    padding: 40px 60px;
    box-sizing: border-box;

    @include not-mobile {
      column-count: 3;
      padding: 3% 0 3% 11%;
    }

    @include landscape {
      column-count: 2;
      padding: 40px 60px;
    }

    @include not-tablet {
      column-count: 4;
    }
  }

  &__list-link {
    display: inline-block;
    font-size: 16px;
    line-height: 34px;
    text-decoration: none;
    color: $c_white;
    @include t_normal;
    line-height: 3.5em;

    &--active {
      @include t_bold;
    }

    b {
      @include t_bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MenuBar.vue